export const validReceiptNumber = (value) =>
  Number.isSafeInteger(value) && value > 0;

// Reject missing/malformed IDs rather than submitting NaN (serialized as null).
// The API must explicitly return 0 when the sequence has no previous receipt.
export const nextReceiptNumber = (lastId) => {
  if (
    !((typeof lastId === "string" && /^\d+$/.test(lastId)) ||
      (typeof lastId === "number" && Number.isSafeInteger(lastId)))
  ) {
    throw new Error("Invalid last receipt number");
  }
  const next = Number(lastId) + 1;
  if (Number(lastId) < 0 || !validReceiptNumber(next)) {
    throw new Error("Invalid next receipt number");
  }
  return next;
};
